import { render, staticRenderFns } from "./GradientCheck.vue?vue&type=template&id=3dbf5600&scoped=true&"
import script from "./GradientCheck.vue?vue&type=script&lang=js&"
export * from "./GradientCheck.vue?vue&type=script&lang=js&"
import style0 from "./GradientCheck.vue?vue&type=style&index=0&id=3dbf5600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf5600",
  null
  
)

export default component.exports